"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticatorUSDInitializer = exports.AuthenticatorDRPicasoInitializer = exports.AuthenticatorCCInitializer = exports.AuthenticatorHybridInitializer = exports.AuthenticatorInitializer = exports.BaseAuthenticatorInitializer = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const xhr_1 = require("../../security/xhr");
const _1 = require(".");
const uiInformation_1 = require("../../uiInformation");
const contactCenter_1 = require("../../contactCenter");
const AUTHENTICATOR_ERROR = 'Authenticator initialization error';
const CHANNEL_WEB = 'WEB';
const PLATFORM_DESKTOP = 'DESKTOP';
const PLATFORMHYBRID = 'HYBRID';
class AuthenticatorInitializationError extends web_ui_framework_1.InitializerError {
    constructor(errorMessage, channel, platform) {
        const message = `[Channel: ${channel}. Platform: ${platform}] ${errorMessage}`;
        super(AUTHENTICATOR_ERROR, message);
    }
}
class BaseAuthenticatorInitializer extends web_ui_framework_1.Initializer {
}
exports.BaseAuthenticatorInitializer = BaseAuthenticatorInitializer;
class AuthenticatorInitializer extends BaseAuthenticatorInitializer {
    constructor(config, session, authoriser) {
        super([session, authoriser]);
        this.launch = async () => {
            try {
                const authoriser = this.authoriser.getInitialized();
                const session = this.session.getInitialized();
                const plugins = [
                    new web_ui_framework_1.XHRAcceptLanguagePlugin(this.config.language),
                    new web_ui_framework_1.XHRBankIdPlugin(this.config.bankId),
                    new xhr_1.XHRTrustedChallengePlugin(authoriser),
                ];
                const AuthApi = new web_ui_framework_1.XHR({ plugins });
                return new _1.MbAuthenticator(session, AuthApi, uiInformation_1.getDeviceUUID);
            }
            catch (e) {
                throw new AuthenticatorInitializationError(e, CHANNEL_WEB, PLATFORM_DESKTOP);
            }
        };
        this.config = config;
        this.authoriser = authoriser;
        this.session = session;
    }
}
exports.AuthenticatorInitializer = AuthenticatorInitializer;
class AuthenticatorHybridInitializer extends BaseAuthenticatorInitializer {
    constructor(session, mobileConnector) {
        super([session, mobileConnector]);
        this.launch = async () => {
            try {
                const hybridAuthenticator = new _1.MbHybridAuthenticator(this.session.getInitialized(), this.mobileConnector.getInitialized().getAccessToken);
                hybridAuthenticator.login();
                return hybridAuthenticator;
            }
            catch (e) {
                throw new AuthenticatorInitializationError(e, CHANNEL_WEB, PLATFORMHYBRID);
            }
        };
        this.session = session;
        this.mobileConnector = mobileConnector;
    }
}
exports.AuthenticatorHybridInitializer = AuthenticatorHybridInitializer;
class AuthenticatorCCInitializer extends BaseAuthenticatorInitializer {
    constructor(config, sessionUSD, sessionDrPicaso, sessionDevCC, authenticatorDrPicaso, modelbankUSDManager) {
        super([sessionUSD, sessionDrPicaso, sessionDevCC, authenticatorDrPicaso, modelbankUSDManager]);
        this.launch = async () => {
            try {
                const sessionUSD = this.sessionUSD.getInitialized();
                const modelbankUsdManager = this.modelbankUSDManager.getInitialized();
                const AuthApi = new web_ui_framework_1.XHR({});
                const authenticatorUSD = new _1.MbUSDAuthenticator(sessionUSD, AuthApi, modelbankUsdManager);
                if (!(0, contactCenter_1.isDevelopmentLogicCCRoute)() &&
                    !this.sessionDevCC.getInitialized().isValid() &&
                    !this.sessionDrPicaso.getInitialized().isValid()) {
                    await authenticatorUSD.login();
                }
                return authenticatorUSD;
            }
            catch (e) {
                throw new AuthenticatorInitializationError(e, CHANNEL_WEB, PLATFORM_DESKTOP);
            }
        };
        this.config = config;
        this.sessionUSD = sessionUSD;
        this.sessionDrPicaso = sessionDrPicaso;
        this.sessionDevCC = sessionDevCC;
        this.authenticatorDrPicaso = authenticatorDrPicaso;
        this.modelbankUSDManager = modelbankUSDManager;
    }
}
exports.AuthenticatorCCInitializer = AuthenticatorCCInitializer;
class AuthenticatorDRPicasoInitializer extends BaseAuthenticatorInitializer {
    constructor(config, session) {
        super([session]);
        this.launch = async () => {
            try {
                const session = this.session.getInitialized();
                const AuthApi = new web_ui_framework_1.XHR({});
                const authenticator = new _1.MbDRPicasoAuthenticator(session, AuthApi, {}); //TODO pending to add helper initializer
                if ((0, contactCenter_1.isDRPicasoRoute)()) {
                    await authenticator.loginAgent();
                }
                return authenticator;
            }
            catch (e) {
                throw new AuthenticatorInitializationError(e, CHANNEL_WEB, PLATFORM_DESKTOP);
            }
        };
        this.config = config;
        this.session = session;
    }
}
exports.AuthenticatorDRPicasoInitializer = AuthenticatorDRPicasoInitializer;
class AuthenticatorUSDInitializer extends BaseAuthenticatorInitializer {
    constructor(config, session, modelbankUSDManager) {
        super([session]);
        this.launch = async () => {
            try {
                const session = this.session.getInitialized();
                const UsdManager = this.modelbankUSDManager.getInitialized();
                const AuthApi = new web_ui_framework_1.XHR({});
                return new _1.MbUSDAuthenticator(session, AuthApi, UsdManager);
            }
            catch (e) {
                throw new AuthenticatorInitializationError(e, CHANNEL_WEB, PLATFORM_DESKTOP);
            }
        };
        this.config = config;
        this.session = session;
        this.modelbankUSDManager = modelbankUSDManager;
    }
}
exports.AuthenticatorUSDInitializer = AuthenticatorUSDInitializer;
//# sourceMappingURL=authenticator.initializers.js.map